<script>
    import { createEventDispatcher } from 'svelte';
    
    const dispatcher = createEventDispatcher();
    let invitationPanel;
    let userData;

    export function show(data)
    {
        userData = data;
        invitationPanel.style.display = "block";
    }

    function hide()
    {
        invitationPanel.style.display = "none";
    }

    function onAccept()
    {
        dispatcher('accept', {originalSender: userData.userId});
        hide();
    }

    function onReject()
    {
        dispatcher('reject', {originalSender: userData.userId});
        hide();
    }

    function onBlock()
    {
        dispatcher('block', {originalSender: userData.userId});
        hide();
    }
</script>

<ion-card class="panel" bind:this={invitationPanel} style="display: none;">
    
    {#if userData}
    <ion-card-content style="text-align: center;">
        <ion-item>
            <div class="center" style="width: 100%;">
                {userData.userName} has sent you a Friend Request.
            </div>
        </ion-item>
        <div class="hbox center" style="padding-top: 15px;">
            <ion-button on:click={onAccept}>Accept</ion-button>
            <ion-button on:click={onReject}>Reject</ion-button>
            <ion-button on:click={onBlock}>Block</ion-button>
        </div>
    </ion-card-content>
    {/if}
</ion-card>

<style>
    .panel {
        position: absolute;
        width: 440px;
        height: 120px;
        left: 180px;
        bottom: 20px;
    }
</style>